import * as tslib_1 from "tslib";
import { Base } from '../base-component';
import './image-link-v2.component.scss';
import * as Swiper from 'swiper/dist/js/swiper.js';
var ImageLinkV2 = /** @class */ (function (_super) {
    tslib_1.__extends(ImageLinkV2, _super);
    function ImageLinkV2(element) {
        return _super.call(this, element) || this;
    }
    ImageLinkV2.prototype.init = function () {
        this.smallSliderContainer = this.element.querySelector('.image-link-v2__carousel--swiper');
        this.smallSlider = new Swiper(this.smallSliderContainer, {
            slidesPerView: 4,
            centeredSlides: false,
            spaceBetween: 30,
            initialSlide: 0,
            breakpoints: {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                1024: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                767: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                580: {
                    initialSlide: 0,
                    slidesPerView: 1.5,
                    spaceBetween: 10,
                },
                480: {
                    initialSlide: 0,
                    slidesPerView: 1.2,
                    spaceBetween: 10,
                }
            },
            freeMode: false,
            navigation: {
                nextEl: '.image-link-v2__carousel--container__rightarrow',
                prevEl: '.image-link-v2__carousel--container__leftarrow',
            }
        });
    };
    ImageLinkV2.prototype.bindEvents = function () {
    };
    ImageLinkV2.prototype.generateBreakpoints = function () {
        var slidesPerView = 0;
        var breakpoints = {};
        // if there are only 3 slides captured
        if (this.swiperContainer.classList.contains('three-items')) {
            slidesPerView = 4;
            breakpoints = {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                1024: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                767: {
                    initialSlide: 0,
                    slidesPerView: 1.3,
                    spaceBetween: 30,
                },
                580: {
                    initialSlide: 0,
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                }
            };
            // if there are only 2 slides captured
        }
        else if (this.swiperContainer.classList.contains('two-items')) {
            slidesPerView = 2;
            breakpoints = {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                1024: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                767: {
                    initialSlide: 0,
                    slidesPerView: 1.3,
                    spaceBetween: 30,
                },
                580: {
                    initialSlide: 0,
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                }
            };
            // if there are only 1 slide captured
        }
        else if (this.swiperContainer.classList.contains('one-item')) {
            slidesPerView = 1;
            // if there are is more than 3 items
        }
        else {
            slidesPerView = 3;
            breakpoints = {
                1200: {
                    initialSlide: 0,
                    slidesPerView: 2.5,
                    spaceBetween: 30,
                },
                1024: {
                    initialSlide: 0,
                    slidesPerView: 2,
                    spaceBetween: 30,
                },
                767: {
                    initialSlide: 0,
                    slidesPerView: 1.3,
                    spaceBetween: 30,
                },
                580: {
                    initialSlide: 0,
                    slidesPerView: 1.1,
                    spaceBetween: 10,
                }
            };
        }
        return {
            slidesPerView: slidesPerView,
            breakpoints: breakpoints
        };
    };
    return ImageLinkV2;
}(Base));
export { ImageLinkV2 };



//////////////////
// WEBPACK FOOTER
// ./components/image-link-v2/image-link-v2.component.ts
// module id = 773
// module chunks = 0